const Slider = (function () {
    'use strict'

    let slider;
    let current;
    let total;
    let flickdata;
    let buttonPrev;
    let buttonNext;

    const init = () => {
        const productslider = $('[data-hook=product-detail-slider]');

        if(productslider.length) {
            current = $('[data-hook=product-pagination-current]');
            total = $('[data-hook=product-pagination-total]');
            buttonPrev = $('[data-behavior=product-slider-prev]');
            buttonNext = $('[data-behavior=product-slider-next]');

            slider = $(productslider).flickity({
                imagesLoaded: true,
                contain: true,
                pageDots: false,
                prevNextButtons: false,
                wrapAround: false,
                cellSelector: '.slider__item',
                adaptiveHeight: true,
            });

            flickdata = slider.data('flickity');
            setCurrent();
            $(total).text(getTotal());

            $(slider).on('dragEnd.flickity', function() {
                setCurrent();
            });

            $(buttonNext).on('click', function() {
                Slider.next();
            });

            $(buttonPrev).on('click', function() {
                Slider.previous();
            });
        }
    };

    const getTotal = function() {
        return flickdata.cells.length;
    }

    const refresh = function() {
        $(slider).flickity('destroy');
        init();
    };

    const destroy = function() {
        $(slider).flickity('destroy');
    };

    const hasPrev = function() {
        return flickdata.selectedIndex > 0;
    };

    const hasNext = function() {
        return flickdata.selectedIndex < getTotal() - 1;
    };

    const updateButtons = function() {
        if (hasPrev()) {
            $(buttonPrev).removeAttr('disabled');
        } else {
            $(buttonPrev).attr('disabled', '');
        }

        if (hasNext()) {
            $(buttonNext).removeAttr('disabled');
        } else {
            $(buttonNext).attr('disabled', '');
        }
    }

    const setCurrent = () => {
        $(current).text(flickdata.selectedIndex+1);
        updateButtons();
    }

    const next = () => {
        slider.flickity('next');
        setCurrent();
    }

    const previous = () => {
        slider.flickity('previous');
        setCurrent();
    }

    return {
        init: init,
        previous: previous,
        next: next,
        refresh: refresh,
        destroy: destroy,
    };
})();
